/**
 * Check Enum / Type exhaustivness, throws an error if param has type other than `never`
 * Use in switch statements to validate that all enum values have been checked.
 * Use This method for values that can't be manipulated by user, e.g. enum that comes from our backe1`
 * @example
 *  switch(enumValue) {
 *    case(Enum.One):
 *      return...
 *    //all other cases
 *    default:
 *      exhaustiveCheck(enumValue)
 * }
 */
export const exhaustiveCheck = (param: never): never => {
  throw new Error(`Failed exhaustive check with param value ${param}`);
};

/**
 * Check Enum / Type exhaustivness, logs warning to the console if param has type other than `never`
 * Use in switch statements to validate that all enum values have been checked.
 * Use This method for values that can be manipulated by user, e.g. queryParams.
 * @example
 *  switch(enumValue) {
 *    case(Enum.One):
 *      return...
 *    //all other cases
 *    default:
 *      exhaustiveCheck(enumValue)
 * }
 */
export const exhaustiveCheckWarn = (param: never): void => {
  console.error(`Failed exhaustive check warning with param value ${param}`);
};
